import GA4Handler from '../GA4Handler'
import { DataLayerNonLinkClick } from '../interfaces'

// @todo-ga4 Refactor this?
const ga4FeedbackModalSubmitHandler = (data: DataLayerNonLinkClick) => {
  GA4Handler.pushObject('ga4FeedbackModalSubmitHandler', data)
}

export default ga4FeedbackModalSubmitHandler
